class StateItem {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

/**
 * 操作需求类型 (OperationRequirementType)
 */
const STORAGE = new StateItem(1, '仓储')
const TRANSPORT = new StateItem(2, '运输')
const CUSTOMS = new StateItem(3, '报关')
const HANDLING_INFO = new StateItem(4, 'Handling Info')

/**
 * 操作需求类型代码列表
 */
const OPERATION_REQUIREMENT = [STORAGE, TRANSPORT, CUSTOMS, HANDLING_INFO]

export default {
  STORAGE,
  TRANSPORT,
  CUSTOMS,
  HANDLING_INFO,
  OPERATION_REQUIREMENT
}
